export default {
  displayFont: 'Arapey, serif',
  bodyFont: 'Montserrat, sans-serif',
  colors: {
    tones: {
      lightest: '#F5F5F5',
      lighter: '#E1E1E1',
      light: '#969696',
      dark: '#373737',
      darker: '#323232'
    },
    primary: '#953155',
    secondary: '#0078DC'
  },
  navHeight: 80,
  fontSizes: {
    xl: {
      xs: 36,
      sm: 40,
      md: 100,
      lg: 100,
      xl: 100
    },
    lg: {
      xs: 20,
      sm: 20,
      md: 36,
      lg: 36,
      xl: 36
    },
    md: {
      xs: 18,
      sm: 18,
      md: 24,
      lg: 24,
      xl: 24
    },
    sm: {
      xs: 18,
      sm: 18,
      md: 18,
      lg: 18,
      xl: 18
    },
    xs: {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12
    }
  },
  lineHeights: {
    xl: {
      xs: 40,
      sm: 36,
      md: 36,
      lg: 54,
      xl: 54
    },
    lg: {
      xs: 50,
      sm: 50,
      md: 50,
      lg: 50,
      xl: 50
    },
    md: {
      xs: 34,
      sm: 34,
      md: 34,
      lg: 34,
      xl: 34
    },
    sm: {
      xs: 26,
      sm: 26,
      md: 26,
      lg: 26,
      xl: 26
    },
    xs: {
      xs: 16,
      sm: 16,
      md: 16,
      lg: 16,
      xl: 16
    }
  },
  fontWeights: {
    thin: 100,
    light: 200,
    normal: 400,
    bold: 600,
    black: 700
  },
  grid: {
    breakpoints: {
      // defaults below
      giant: 1200,
      xl: 1200,
      desktop: 992,
      lg: 992,
      tablet: 768,
      md: 768,
      phone: 576,
      sm: 576,
      smaller: 575,
      xs: 575
    },
    row: {
      padding: 10 // default 15
    },
    col: {
      padding: 10 // default 15
    },
    container: {
      padding: 40 // default 15
    }
  }
}



// WEBPACK FOOTER //
// ./src/ui/styles/theme.js